<template>
  <div id="sss">
    <div class="login" style="position:relative;">
      <h1
        style="width:100%; text-align:center;margin-top:30px; margin-bottom:0;"
      >
        E滁州案例集管理系统
      </h1>
      <a-form :form="form">
        <a-form-item
          :wrapper-col="formItemLayout.wrapperCol"
          class="login-form"
        >
          <a-input
            maxlength="50"
            v-decorator="[
              'username',
              {
                initialValue: username,
                rules: [{ required: true, message: '用户名未填写' }]
              }
            ]"
            placeholder="用户名"
          />
        </a-form-item>
        <a-form-item :wrapper-col="formItemLayout.wrapperCol">
          <a-input-password
            type="password"
            maxlength="50"
            v-decorator="[
              'password',
              {
                initialValue: password,
                rules: [{ required: true, message: '密码未填写' }]
              }
            ]"
            placeholder="密码"
          />
        </a-form-item>
        <a-form-item :wrapper-col="formTailLayout.wrapperCol">
          <a-checkbox :checked="checkNick" @change="handleChange"
            >记住用户名和密码</a-checkbox
          >
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="check" style="width:100%;"
            >登录</a-button
          >
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 }
};
const formTailLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 }
};
export default {
  data() {
    return {
      checkNick: false,
      formItemLayout,
      formTailLayout,
      username: "",
      password: "",
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
      isMobile: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      console.log(this.$route);
      if (this.$store.getters.getToken) {
        this.$router.push({
          path: "/"
        });
      } else if (localStorage.getItem("username")) {
        this.username = localStorage.getItem("username");
        this.password = localStorage.getItem("password");
        this.checkNick = true;
      }
    },
    check() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.checkNick) {
            localStorage.setItem("username", values.username);
            localStorage.setItem("password", values.password);
          } else {
            localStorage.setItem("username", "");
            localStorage.setItem("password", "");
          }

          this.api.login(values, res => {
            if (res.success) {
              let permissions = [];
              for (let i = 0; i < res.data.permissions.length; i++) {
                permissions.push(res.data.permissions[i].fields.name);
              }
              console.log(permissions);
              res.data.user["permissions"] = permissions;
              res.data.user["photo"] = res.data.photo;
              res.data.user["group"] = res.data.group;
              this.$store.dispatch(
                "setToken",
                res.data.user.fields.accessToken
              );
              this.$store.dispatch("setUser", res.data.user);
              this.$router.push({
                path: "/"
              });
            } else {
              this.$notification.warning({
                key: "login",
                message: "失败！",
                description: res.message
              });
            }
          });
        }
      });
    },
    handleChange(e) {
      this.checkNick = e.target.checked;
    }
  }
};
</script>

<style lang="less" scoped>
#sss {
  background: url("../../assets/index_bg.png") no-repeat center center;
  background-size: 100% 100%;
  height: 100vh;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-content: center;
  padding: 10px;
}
.login {
  max-width: 500px;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background: #fff;
  height: 440px;
  margin-top: 20vh;
  border-radius: 20px;
}
.login-form {
  width: 300px;
  margin-top: 0px;
}
</style>
